import { Typography } from "@mui/material";
import PropTypes from "prop-types";

function PageTitle({ disableGutters = false, children, sx, ...props }) {
  return (
    <Typography
      variant="h5"
      component="h2"
      sx={[
        {
          py: 0,
          px: disableGutters ? 0 : 2,
          my: 1.5,
          mx: 0,
          flexGrow: 1,
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...props}
    >
      {children}
    </Typography>
  );
}

PageTitle.propTypes = {
  sx: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  disableGutters: PropTypes.bool,
};

export default PageTitle;
